import {db} from './db.js';
import {isTeacher} from './commonHelpers.js';

import {
  getValidToolsOptions,
  getValidGradesOptions,
  getValidPeopleOptions,
  getValidDepartmentsOptions
} from './stateOptionsHelpers';

export function updatePeopleWithSchool(state, schoolId) {
  const peopleOptions = getValidPeopleOptions(db, schoolId);

  return {
    ...state,
    people: {
      ...state.people,
      options: peopleOptions
    }
  };
}

export function updateToolsWithPerson(state, personId) {
  const toolsOptions = getValidToolsOptions(db, personId, state);

  return {
    ...state,
    tools: {
      ...state.tools,
      options: toolsOptions
    }
  }
}

export function updateDepartmentsWithPerson(state, personId) {
  if (!isTeacher(personId)) {
    return {
      ...state,
      departments: {
        ...state.departments,
        options: []
      }
    }
  }

  const departmentsOptions = getValidDepartmentsOptions(db, personId, state);

  return {
    ...state,
    departments: {
      ...state.departments,
      options: departmentsOptions
    }
  }
}

export function updateGradesWithPerson(state, personId) {
  if (!isTeacher(personId)) {
    return {
      ...state,
      grades: {
        ...state.grades,
        options: []
      }
    }
  }

  const gradesOptions = getValidGradesOptions(db, personId, state);

  return {
    ...state,
    grades: {
      ...state.grades,
      options: gradesOptions
    }
  }
}

export function resetJobTitle(state) {
  /* Intentionally not resetting this to preserve jobTitle */
  return {
    ...state
  };
}
